// Omnix/client/widgets/MyOpenTicketsWidget.js
export default {
    name: "MyOpenTicketsWidget",
    description: "Displays tickets of the user that are still open.",
    type: "DataWidget",
    roles: ["user"],
    widget: {
        title: "My Open Tickets",
        dataProvider: {
            main: {
                rpc: "UserDashboardRpc.getMyOpenTickets",
                transform: (response) => response?.data || []
            }
        },
        itemAction: {
            type: 'navigate',
            route: '/user/tickets?ticketId={{_id}}'
        },
        // --- IMPROVEMENT: Use a fully custom itemTemplate for a card layout ---
        itemTemplate: (item) => {
            const statusStyles = {
                'new': { color: 'danger', text: 'New' },
                'pending': { color: 'warning', text: 'Pending' },
                'open': { color: 'info', text: 'Open' }
            };
            const priorityStyles = {
                'high': { color: 'danger', icon: 'bi-chevron-double-up' },
                'normal': { color: 'warning', icon: 'bi-grip-vertical' },
                'low': { color: 'secondary', icon: 'bi-chevron-down' }
            };
            
            const status = statusStyles[item.status] || { color: 'secondary', text: item.status };
            const priority = priorityStyles[item.priority] || { color: 'secondary', icon: 'bi-question-circle' };
            const creationDate = new Date(item.createdAt).toLocaleDateString([], { month: 'short', day: 'numeric' });

            return `
                <style>
                    .ticket-card {
                        padding: 0.75rem;
                        border-left: 4px solid var(--bs-${status.color});
                        background-color: var(--bs-tertiary-bg);
                        border-radius: var(--bs-border-radius);
                        margin-bottom: 0.5rem;
                    }
                </style>
                <div class="ticket-card">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                            <div class="fw-bold">${item.subject}</div>
                            <small class="text-muted">#${item.ticketNumber} • Created: ${creationDate}</small>
                        </div>
                        <div class="text-nowrap ms-3">
                             <span class="badge bg-${status.color}">${status.text}</span>
                        </div>
                    </div>
                </div>
            `;
        },
        noDataMessage: "You have no open tickets."
    }
};